/* FT GUYS - swipe a product card to slide through its colourways.

   .ft-grid__card (homepage featured) and .ft-chapter__card (collection).
   Colours come from /products/<handle>.js on first interaction with a card.

   Three absolutely-positioned slots in a wrapper - prev at -100%, current at 0,
   next at +100% - translated by the drag delta. Release completes or springs back.

   REVEAL VIDEO INTERPLAY (ft-guys.js): with no custom.reveal_color set, the reveal
   video holds its last frame (.is-held) over the photo. Swiping under an opaque
   video looked dead, so any swipe dismisses it and re-syncs the index to the
   colour actually on screen.

   HINT: every card announces itself the moment its own reveal clip ends - no
   queue, no single-slot gate, no delay beyond a frame or two. Cards with no reveal
   video fall back to announcing on visibility. Each hint sits at the BOTTOM edge
   so it never covers the print, and persists until that card is swiped.
   The one restraint kept: the first real swipe anywhere clears every hint and
   stops new ones - past that point the user knows the gesture and repeating it
   is nagging, not teaching.
*/
(function () {
  'use strict';

  var SELECTORS = '.ft-grid__card, .ft-chapter__card';
  var THRESHOLD = 0.18;
  var MIN_PX = 36;
  var SLIDE_MS = 320;
  var HINT_DELAY = 120;
  var HINT_VISIBILITY = 0.35;
  var EASE = 'cubic-bezier(.22,1,.36,1)';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia('(hover: none)').matches;
  var cache = new Map();
  var swipedAt = 0;
  var gestureLearned = false;

  function sized(src, width) {
    try {
      var u = new URL(src, window.location.origin);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) { return src; }
  }

  function slotWidth(card) {
    var w = Math.round(card.getBoundingClientRect().width * (window.devicePixelRatio || 1));
    var steps = [300, 450, 600, 900, 1200];
    for (var i = 0; i < steps.length; i++) if (w <= steps[i]) return steps[i];
    return 1200;
  }

  function colourList(data) {
    var idx = -1;
    (data.options || []).forEach(function (o, i) {
      var name = (typeof o === 'string' ? o : (o && o.name) || '').toLowerCase();
      if (name.indexOf('colour') > -1 || name.indexOf('color') > -1) idx = i;
    });
    var seen = {}, out = [];
    (data.variants || []).forEach(function (v) {
      var label = idx >= 0 && v.options ? v.options[idx] : v.title;
      if (!label || seen[label]) return;
      var src = v.featured_image && v.featured_image.src;
      if (!src) return;
      seen[label] = true;
      out.push({ name: label, src: src, id: v.id });
    });
    return out;
  }

  function anchorOf(card) {
    return card.matches('a') ? card : card.querySelector('a[href*="/products/"]');
  }

  function load(card) {
    var a = anchorOf(card);
    if (!a) return Promise.resolve(null);
    var url = a.getAttribute('href').split('?')[0];
    if (cache.has(url)) return Promise.resolve(cache.get(url));
    var p = fetch(url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var list = d ? colourList(d) : null;
        cache.set(url, list);
        return list;
      })
      .catch(function () { cache.set(url, null); return null; });
    cache.set(url, p);
    return p;
  }

  function clearHeldVideo(card) {
    var v = card.querySelector('video.is-held, video.is-playing');
    if (!v) return;
    v.classList.remove('is-held');
    v.classList.remove('is-playing');
    try { v.pause(); } catch (e) {}
  }

  var style = document.createElement('style');
  style.textContent =
    '.ft-swipe-track{position:absolute;inset:0;will-change:transform;}' +
    '.ft-swipe-slot{position:absolute !important;inset:0;width:100%;height:100%;display:block;}' +
    '.ft-swipe-ui{position:absolute;left:0;right:0;bottom:8px;display:flex;align-items:center;justify-content:center;gap:5px;z-index:3;pointer-events:none;opacity:0;transition:opacity .25s ease;}' +
    '.ft-swipe-ui.is-on{opacity:1;}' +
    '.ft-swipe-dot{width:5px;height:5px;border-radius:50% !important;background:rgba(7,6,5,.35);transition:background .2s ease,transform .2s ease;}' +
    '.ft-swipe-dot.is-active{background:#ff5c1a;transform:scale(1.5);}' +
    '.ft-swipe-name{position:absolute;left:10px;bottom:8px;z-index:3;pointer-events:none;font:700 10px Archivo,sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#f5efe8;background:rgba(7,6,5,.66);padding:4px 8px;opacity:0;transition:opacity .25s ease;}' +
    '.ft-swipe-name.is-on{opacity:1;}' +
    '.ft-swipe-hint{position:absolute;left:50%;bottom:10px;z-index:5;pointer-events:none;display:flex;align-items:center;gap:8px;' +
    'font:700 10px Archivo,sans-serif;letter-spacing:.16em;text-transform:uppercase;color:#f5efe8;' +
    'background:rgba(7,6,5,.74);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);' +
    'border:1px solid rgba(245,239,232,.26);padding:8px 12px;white-space:nowrap;' +
    'opacity:0;transform:translate(-50%,8px);' +
    'transition:opacity .4s cubic-bezier(.22,1,.36,1),transform .5s cubic-bezier(.22,1,.36,1);}' +
    '.ft-swipe-hint.is-on{opacity:1;transform:translate(-50%,0);}' +
    '.ft-swipe-hint__arrow{display:inline-block;color:#ff5c1a;animation:ftHintNudge 1.6s ease-in-out infinite;}' +
    '.ft-swipe-hint__arrow--l{animation-delay:.18s;}' +
    '@keyframes ftHintNudge{0%,100%{transform:translateX(0);opacity:.5;}50%{transform:translateX(3px);opacity:1;}}' +
    '@media (prefers-reduced-motion:reduce){.ft-swipe-hint{transition:none;}.ft-swipe-hint__arrow{animation:none;opacity:1;}}';
  document.head.appendChild(style);

  function mediaOf(card) {
    return card.querySelector('.ft-grid__media, .ft-chapter__media');
  }

  /* ---------- swipe hint ---------- */

  function removeHint(card) {
    if (!card) return;
    var h = card.querySelector('.ft-swipe-hint');
    if (!h) return;
    h.classList.remove('is-on');
    setTimeout(function () { if (h.parentNode) h.remove(); }, 600);
  }

  function removeAllHints() {
    document.querySelectorAll('.ft-swipe-hint').forEach(function (h) {
      h.classList.remove('is-on');
      setTimeout(function () { if (h.parentNode) h.remove(); }, 600);
    });
  }

  function showHint(card, st) {
    if (gestureLearned || !st.colours || st.colours.length < 2) return;
    var media = mediaOf(card);
    if (!media || media.querySelector('.ft-swipe-hint')) return;

    var hint = document.createElement('div');
    hint.className = 'ft-swipe-hint';
    hint.setAttribute('role', 'status');
    hint.innerHTML =
      '<span class="ft-swipe-hint__arrow ft-swipe-hint__arrow--l" aria-hidden="true">&#8592;</span>' +
      '<span>' + (touch ? 'Swipe for colours' : 'Drag for colours') + '</span>' +
      '<span class="ft-swipe-hint__arrow" aria-hidden="true">&#8594;</span>';
    media.appendChild(hint);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hint.classList.add('is-on'); });
    });
  }

  function offerHint(card) {
    if (gestureLearned || !card) return;
    var media = mediaOf(card);
    if (media && media.querySelector('.ft-swipe-hint')) return;
    var st = ensure(card);
    var go = function () {
      if (gestureLearned) return;
      if (st.colours) showHint(card, st);
    };
    if (st.colours) setTimeout(go, HINT_DELAY);
    else load(card).then(function () { setTimeout(go, HINT_DELAY); });
  }

  /* Each card's own reveal ending is its cue. 'ended' does not bubble - capture. */
  document.addEventListener('ended', function (e) {
    var v = e.target;
    if (!v || !v.matches || !v.matches('[data-ft-reveal-video]')) return;
    var card = v.closest(SELECTORS);
    if (card) offerHint(card);
  }, true);

  /* Cards with no reveal video (or where it never plays) announce on visibility,
     so no product is left without the affordance. */
  if ('IntersectionObserver' in window) {
    var hintIO = new IntersectionObserver(function (entries) {
      if (gestureLearned) { hintIO.disconnect(); return; }
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var card = e.target;
        var v = card.querySelector('[data-ft-reveal-video]');
        // A clip that has not finished yet will fire its own cue shortly.
        if (v && !v.ended && !v.dataset.ftPlayed) {
          setTimeout(function () { if (!v.ended) offerHint(card); }, 1400);
          return;
        }
        offerHint(card);
      });
    }, { threshold: HINT_VISIBILITY });

    var watchCards = function (scope) {
      (scope || document).querySelectorAll(SELECTORS).forEach(function (c) { hintIO.observe(c); });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { watchCards(); });
    } else {
      watchCards();
    }
    document.addEventListener('shopify:section:load', function (e) { watchCards(e.target); });
  }

  function syncIndexToVisible(card, st) {
    var img = card.querySelector('[data-ft-photo]');
    var current = img && (img.getAttribute('src') || '');
    if (!current) return;
    var bare = current.split('?')[0];
    for (var n = 0; n < st.colours.length; n++) {
      if (st.colours[n].src.split('?')[0] === bare) { st.i = n; return; }
    }
  }

  function buildTrack(card, st) {
    if (st.track) return true;
    var media = mediaOf(card);
    var img = card.querySelector('[data-ft-photo]');
    if (!media || !img) return false;

    media.style.overflow = 'hidden';
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
    media.style.touchAction = 'pan-y';

    var track = document.createElement('div');
    track.className = 'ft-swipe-track';
    media.insertBefore(track, img);

    var prev = img.cloneNode(false);
    var next = img.cloneNode(false);
    [prev, next].forEach(function (n) {
      n.removeAttribute('data-ft-photo');
      n.removeAttribute('srcset');
      n.removeAttribute('sizes');
      n.removeAttribute('id');
      n.classList.add('ft-swipe-slot');
      n.setAttribute('aria-hidden', 'true');
      n.setAttribute('alt', '');
      n.decoding = 'async';
    });
    img.classList.add('ft-swipe-slot');

    track.appendChild(prev);
    track.appendChild(img);
    track.appendChild(next);

    prev.style.transform = 'translate3d(-100%,0,0)';
    next.style.transform = 'translate3d(100%,0,0)';

    st.track = { el: track, prev: prev, cur: img, next: next, media: media };
    syncIndexToVisible(card, st);
    fillNeighbours(card, st);
    return true;
  }

  function at(st, i) {
    var n = st.colours.length;
    return st.colours[((i % n) + n) % n];
  }

  function fillNeighbours(card, st) {
    if (!st.track || !st.colours) return;
    var w = slotWidth(card);
    st.track.prev.src = sized(at(st, st.i - 1).src, w);
    st.track.next.src = sized(at(st, st.i + 1).src, w);
  }

  function buildUI(card, st) {
    var media = mediaOf(card);
    if (!media || st.ui || st.colours.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'ft-swipe-ui';
    for (var i = 0; i < st.colours.length; i++) {
      var d = document.createElement('span');
      d.className = 'ft-swipe-dot' + (i === st.i ? ' is-active' : '');
      dots.appendChild(d);
    }
    var name = document.createElement('span');
    name.className = 'ft-swipe-name';
    media.appendChild(dots);
    media.appendChild(name);
    st.ui = { dots: dots, name: name };
  }

  function paintUI(st) {
    if (!st.ui) return;
    st.ui.dots.classList.add('is-on');
    st.ui.name.classList.add('is-on');
    st.ui.name.textContent = at(st, st.i).name;
    Array.prototype.forEach.call(st.ui.dots.children, function (d, n) {
      d.classList.toggle('is-active', n === st.i);
    });
    clearTimeout(st.hideT);
    st.hideT = setTimeout(function () {
      st.ui.dots.classList.remove('is-on');
      st.ui.name.classList.remove('is-on');
    }, 1800);
  }

  function syncHref(card, st) {
    var a = anchorOf(card);
    if (!a) return;
    a.setAttribute('href', a.getAttribute('href').split('?')[0] + '?variant=' + at(st, st.i).id);
  }

  function settle(card, st, dir) {
    var t = st.track;
    var width = t.media.getBoundingClientRect().width;
    var to = dir === 0 ? 0 : (dir > 0 ? -width : width);

    t.el.style.transition = 'transform ' + SLIDE_MS + 'ms ' + EASE;
    t.el.style.transform = 'translate3d(' + to + 'px,0,0)';

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      t.el.removeEventListener('transitionend', finish);

      if (dir !== 0) {
        st.i = ((st.i + dir) % st.colours.length + st.colours.length) % st.colours.length;
        var w = slotWidth(card);
        t.cur.removeAttribute('srcset');
        t.cur.removeAttribute('sizes');
        t.cur.src = sized(at(st, st.i).src, w);
        t.prev.src = sized(at(st, st.i - 1).src, w);
        t.next.src = sized(at(st, st.i + 1).src, w);
        syncHref(card, st);
        paintUI(st);
      }

      t.el.style.transition = 'none';
      t.el.style.transform = 'translate3d(0,0,0)';
      void t.el.offsetWidth;
    }

    t.el.addEventListener('transitionend', finish);
    setTimeout(finish, SLIDE_MS + 120);
  }

  var active = null;

  function ensure(card) {
    if (card._ftSwipe) return card._ftSwipe;
    var st = { i: 0, colours: null, ui: null, track: null, hideT: 0 };
    card._ftSwipe = st;
    load(card).then(function (list) {
      if (!list || list.length < 2) return;
      st.colours = list;
      buildTrack(card, st);
      buildUI(card, st);
    });
    return st;
  }

  ['pointerenter', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var card = e.target.closest ? e.target.closest(SELECTORS) : null;
      if (card) ensure(card);
    }, { capture: true, passive: true });
  });

  document.addEventListener('pointerdown', function (e) {
    var card = e.target.closest ? e.target.closest(SELECTORS) : null;
    if (!card) return;
    var st = ensure(card);
    if (!st.colours || !st.track) return;
    active = { card: card, st: st, x: e.clientX, y: e.clientY, claimed: false };
    st.track.el.style.transition = 'none';
  }, { capture: true, passive: true });

  document.addEventListener('pointermove', function (e) {
    if (!active) return;
    var dx = e.clientX - active.x;
    var dy = e.clientY - active.y;

    if (!active.claimed) {
      if (Math.abs(dy) > Math.abs(dx)) { active = null; return; }
      if (Math.abs(dx) < 8) return;
      active.claimed = true;
      gestureLearned = true;
      removeAllHints();
      clearHeldVideo(active.card);
      syncIndexToVisible(active.card, active.st);
      fillNeighbours(active.card, active.st);
    }
    if (reduced) return;
    active.st.track.el.style.transform = 'translate3d(' + dx + 'px,0,0)';
  }, { capture: true, passive: true });

  function release(e) {
    if (!active) return;
    var a = active;
    active = null;
    if (!a.claimed) { a.st.track.el.style.transform = 'translate3d(0,0,0)'; return; }

    var dx = (e.clientX || 0) - a.x;
    var width = a.st.track.media.getBoundingClientRect().width || 1;
    var far = Math.abs(dx) > Math.max(MIN_PX, width * THRESHOLD);

    swipedAt = Date.now();
    settle(a.card, a.st, far ? (dx < 0 ? 1 : -1) : 0);
  }

  document.addEventListener('pointerup', release, { capture: true, passive: true });
  document.addEventListener('pointercancel', function () {
    if (!active) return;
    var a = active;
    active = null;
    settle(a.card, a.st, 0);
  }, { capture: true, passive: true });

  document.addEventListener('click', function (e) {
    if (Date.now() - swipedAt > 350) return;
    if (!e.target.closest || !e.target.closest(SELECTORS)) return;
    e.preventDefault();
    e.stopPropagation();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var el = document.activeElement;
    var card = el && el.closest ? el.closest(SELECTORS) : null;
    if (!card) return;
    var st = ensure(card);
    if (!st.colours || !st.track) return;
    gestureLearned = true;
    removeAllHints();
    clearHeldVideo(card);
    syncIndexToVisible(card, st);
    fillNeighbours(card, st);
    swipedAt = Date.now();
    settle(card, st, e.key === 'ArrowRight' ? 1 : -1);
  });
})();
